import { DragEvent, ReactNode } from 'react';
import { useTheme } from '@mui/material';
import DSBox from './DSBox';

type DSDraggableCardProps = {
  children: ReactNode;
  originalIndex: number;
  displayIndex: number;
  isDragging: boolean;
  handleDragStart: (e: DragEvent<HTMLDivElement>, index: number) => void;
  handleDragEnd: () => void;
  handleDragOver: (e: DragEvent<HTMLDivElement>) => void;
  handleDragEnter: (index: number) => void;
};

const DSDraggableCard = ({
  children,
  originalIndex,
  displayIndex,
  isDragging,
  handleDragStart,
  handleDragEnd,
  handleDragOver,
  handleDragEnter,
}: DSDraggableCardProps) => {
  const theme = useTheme();
  const { spacing, palette } = theme;

  return (
    <DSBox
      draggable
      onDragStart={(e: DragEvent<HTMLDivElement>) =>
        handleDragStart(e, originalIndex)
      }
      onDragEnd={handleDragEnd}
      onDragOver={handleDragOver}
      onDragEnter={() => handleDragEnter(displayIndex)}
      sx={{
        cursor: isDragging ? 'grabbing' : 'grab',
        opacity: isDragging ? theme.dragAndDrop.draggedOpacity : 1,
        transform: isDragging ? 'scale(0.98)' : 'scale(1)',
        transition: theme.dragAndDrop.transition,
        userSelect: 'none',
        willChange: 'transform, opacity',
        borderRadius: spacing(2),
        border: isDragging
          ? `2px dashed ${palette.white[56]}`
          : '2px solid transparent',
      }}
    >
      {children}
    </DSBox>
  );
};

export default DSDraggableCard;
